<template>
  <v-container>
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="dailyFlight.plane_id"
          field-name="plane_id"
          label="reg_num"
          source-type="planes-all"
          filter="plc_02"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <data-selector
          v-model="dailyFlight.pic_id"
          field-name="pic_id"
          label="glider_pic"
          source-type="pilots"
        />
      </v-col>
      <v-col
        cols="12"
        md="1"
      >
        <v-btn
          block
          large
          max-width="0"
          @click="swap()"
        >
          <v-icon> {{ '$swap' }} </v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <data-selector
          v-model="dailyFlight.sic_id"
          field-name="sic_id"
          label="glider_sic"
          source-type="pilots"
          rules=""
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <glider-takeoff-type
          v-model="dailyFlight.takeoff_type_id"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <data-selector
          v-model="dailyFlight.instructor_id"
          :disabled="dailyFlight.sic_id !== null"
          field-name="instructor_id"
          label="instructor_id"
          source-type="instructors"
          rules=""
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <data-selector
          v-model="dailyFlight.tow_plane_id"
          :disabled="dailyFlight.takeoff_type_id !== 'tof_02'"
          field-name="tow_plane_id"
          label="tow_plane_id"
          source-type="tow-planes"
          rules=""
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <airport-selector
          v-model="dailyFlight.takeoff_airport_id"
          field-name="airport"
          :disabled="$route.name !== 'RFID'"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <time-field
          v-model="dailyFlight.takeoff_time"
          field-name="takeoff_time"
          rules="time"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <time-field
          v-model="dailyFlight.landing_time"
          field-name="landing_time"
          rules="time"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <time-field
          v-model="dailyFlight.tow_landing_time"
          :disabled="dailyFlight.takeoff_type_id !== 'tof_02'"
          field-name="tow_landing_time"
          rules="time"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="dailyFlight.task_id"
          field-name="task"
          source-type="tasks"
          translate
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="dailyFlight.comment"
          field-name="comment"
          rules="max:500"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="dailyFlight.tow_altitude"
          :disabled="dailyFlight.takeoff_type_id !== 'tof_02'"
          field-name="tow_altitude"
          rules=""
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="dailyFlight.payer_id"
          field-name="payer_id"
          label="payer_id"
          rules=""
          source-type="users"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="dailyFlight.alter_price"
          field-name="alter_price"
          rules="numeric"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="dailyFlight.pay_comment"
          field-name="pay_comment"
          rules="max:500"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="dailyFlight.cost_sharing"
          :disabled="!dailyFlight.sic_id"
          :label="$t('fields.cost_sharing')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'DailyFlight',
    props: {
      dailyFlight: Object,
    },
    data: () => ({
      technical_users: [1, 2],
      auto_task_set: true,
    }),
    computed: {
      datas: get('datasource/datas'),
      pic_id () { return this.dailyFlight.pic_id },
    },
    watch: {
      'dailyFlight.sic_id': {
        handler () {
          // console.log('Clear Instructor')
          if (this.dailyFlight.sic_id !== null) {
            this.dailyFlight.instructor_id = null
          }
        },
        // deep: true,
      },
      dailyFlight: {
        handler () {
          console.log(this.dailyFlight)
          if (!this.auto_task_set) {
            console.log('Auto Task Set Disabled')
          // } else if (!Object.prototype.hasOwnProperty.call(this.dailyFlight, 'id')) {
          //  console.log('PIC nélkül nincs automatizálás!')
          } else if (this.dailyFlight.task_id === 'tsk_05') {
            console.log('CHK! nem változik a feladat')
          } else if (this.technical_users.includes(this.dailyFlight.pic_id) || this.technical_users.includes(this.dailyFlight.sic_id)) {
            console.log('Technical User! nem változik a feladat')
          } else if (this.dailyFlight.instructor_id) {
            this.dailyFlight.task_id = 'tsk_01'
            this.dailyFlight.sic_id = null
            this.auto_task_set = false
            console.log('oktatás mert van indító oktató')
            console.log(this.dailyFlight.instructor_id)
            console.log('oktatás mert van indító oktató')
          } else if (this.dailyFlight.pic_id !== null && this.dailyFlight.sic_id !== null) {
            const pic = this.datas.pilots.filter(f => f.id === this.dailyFlight.pic_id)
            if ((pic.length) > 0) {
              if (pic[0].is_instructor) {
                this.dailyFlight.task_id = 'tsk_01'
                this.auto_task_set = false
                console.log('oktatás mert a PIC oktató')
              } else {
                this.dailyFlight.task_id = 'tsk_03'
                this.auto_task_set = false
                console.log('privát mert a PIC nem oktató')
              }
            }
          } else if (this.dailyFlight.task_id === 'tsk_01') {
            this.dailyFlight.task_id = 'tsk_03'
            console.log('privát')
          }
        },
        deep: true,
      },
    },
    methods: {
      swap () {
        console.log('SWAP')
        const tmp = this.dailyFlight.pic_id
        this.dailyFlight.pic_id = this.dailyFlight.sic_id
        this.dailyFlight.sic_id = tmp
      },
    },
  }
</script>
